import { Disclosure } from "@headlessui/react";
import { FAQSectionTitle } from "./components/faq-section-title";
import { FAQButton } from "./components/faq-button";
import { FAQItem } from "./components/faq-item";
import { Text } from "../../components/text";

export const FAQAboutJooalan = () => {
  return (
    <>
      <FAQSectionTitle>Tentang Jooalan</FAQSectionTitle>

      <Disclosure>
        <FAQButton>Apa itu Jooalan?</FAQButton>
        <FAQItem>
          <Text>
            Jooalan adalah platform B2B Commerce untuk para Reseller & Dropshipper dengan beragam produk yang terkurasi dan memiliki jaminan produk viral serta memiliki jangkauan komunitas reseller di seluruh Indonesia. Produk yang Anda beli di Jooalan dapat Anda jual kembali di platform marketplace maupun sosial media Anda untuk mendapatkan keuntungan.
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>Produk apa saja yang dijual di Jooalan?</FAQButton>
        <FAQItem>
          <Text>
            Jooalan menyediakan beragam produk unik dan viral yaitu produk rumah tangga, ibu dan anak, perlengkapan ibadah, dan kesehatan. Kalo jual produk dari Jooalan, toko Anda bisa mendapat potensi keuntungan hingga 50%!
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Apa itu Reseller pada aplikasi Jooalan?
        </FAQButton>
        <FAQItem>
          <Text>
            Reseller Jooalan adalah para pelaku usaha yang membeli produk dari katalog Jooalan kemudian menjualkan produk tersebut kepada konsumennya, baik melalui marketplace online, sosial media maupun secara offline dengan menggunakan harga jual sesuai dengan yang ditentukan masing-masing. Reseller melakukan stok barang terlebih dahulu sebelum menjualnya kepada konsumen.
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>Apa itu Dropshipper pada aplikasi Jooalan?</FAQButton>
        <FAQItem>
          <Text>
            Dropshipper Jooalan adalah para pelaku usaha yang memesan produk dari katalog Jooalan kemudian meneruskan pesanan tersebut kepada konsumennya, baik melalui marketplace online, sosial media maupun secara offline dengan menggunakan harga jual sesuai dengan yang ditentukan masing-masing. Dropshipper hanya perlu memasarkan dan menjual barang Jooalan tanpa harus melakukan stok.
          </Text>
        </FAQItem>
      </Disclosure>
    </>
  )
}